// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Card from 'common/components/Card';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { isDevFlagEnabled } from 'common/components/DevFlag';
import { Table, THead, TBody, Th, Tr, Td } from './CustomerTable';
import CustomerEntryAdmin from './CustomerEntryAdmin';
import RadioCustomer from '../types/RadioCustomer';

const FullRowTr = styled(Tr)`
  pointer-events: none;
  height: 100px;
`;

const FullRowTd = styled(Td)`
  text-align: center;
  padding: 0;
`;

type Props = {
  customers: Array<RadioCustomer>,
  loading: boolean,
  onEditOpen: (customer: RadioCustomer) => void,
  onDeleteCustomer: (customer: RadioCustomer) => void,
  t: any,
};

function CustomerListAdmin({ customers, loading, onEditOpen, onDeleteCustomer, t }: Props) {
  const noCustomers = customers.length === 0;
  const headers = isDevFlagEnabled('EDIT_RADIOCUSTOMER') ? [t('callSign'), t('company'), t('fullname'), t('email'), t('folloAccess'), t('actions')] :
                                                               [t('invitation'), t('company'), t('contact'), t('actions')];
  return (
    <Card>
      <Table>
        <THead>
          <Tr>
            {headers.map(title => <Th key={title}>{title}</Th>)}
          </Tr>
        </THead>
        <TBody>
          {!loading && customers.map(customer =>
            <CustomerEntryAdmin
              key={customer.reference}
              customer={customer}
              onEditCustomer={onEditOpen}
              onDeleteCustomer={onDeleteCustomer}
            />)
          }
          {!loading && noCustomers &&
            <FullRowTr>
              <FullRowTd colSpan={headers.length}>{t('noCustomerToManage')}</FullRowTd>
            </FullRowTr>
          }
          {loading && <FullRowTr><FullRowTd colSpan={headers.length}><LoadingSpinner size="small" /></FullRowTd></FullRowTr>}
        </TBody>
      </Table>
    </Card>
  );
}

export default translate('customers')(CustomerListAdmin);



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/CustomerListAdmin.js